<form [formGroup]="ContentQuestionsCourses">
    <fieldset class="col-12">
        <legend>
            <span>Registro</span>
        </legend>

        <div class="card">
            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-10">
                        <label>Modulo</label>
                        <select class="form-control" formControlName="mod_in_id" [(ngModel)]="default_select_module_empty"
                            (change)="onChangeModuleQuestion($event.target.value)">
                            <option value="">Seleccionar</option>
                            <ng-container *ngFor="let module of moduleList">
                                <option value="{{module.coquti_bi_id}}">{{module.mod_vc_name}}
                                </option>
                            </ng-container>
                        </select>
                    </div>
                    <div class="form-group col-md-2">
                        <label class="col-md-12">&nbsp;</label>
                        <button (click)="addquestion()"  class="btn btn-badminton btn-sm pull-right">Agregar
                            Pregunta</button>
                    </div>
                </div>
                
            </div>
        </div>

    </fieldset>
 

 <div *ngIf="bPermission">
    <div class="card">
        <div class="card-body">
            <fieldset class="col-12">
                <legend>Encuesta</legend>
                <div class="card">
                    <div class="card-body">
                        <ng-container *ngFor="let item of dataQuiz;let i = index">
                            <div class="form-row">
                                <div class="form-group col-md-8">
                                    <h2>{{i+1}}. {{ item.coqu_tx_description}}</h2>
                                </div>
                                <div class="form-group col-md-4">
                                    <label style="font-size: 7px;" class="col-md-12">&nbsp;</label>
                                    <a  (click)="deletequestion(item)"  class="pr-2"><i class="fa fa-remove"></i> Eliminar Pregunta {{i+1}}</a>
                                </div>
                            </div>
                          
                           

                            <div class="form-row">
                                <div *ngIf="item.coqu_in_quiz_type==1" class="form-group col-md-6">
                                    <button (click)="addHeader(item)" class="btn btn-badminton btn-sm pull-right">Agregar
                                        Cabecera</button>
                                </div>
                                <div *ngIf="item.coqu_in_quiz_type!=4" class="form-group col-md-6">
                                    <button (click)="addBody(item)"   class="btn btn-badminton btn-sm pull-right">Agregar
                                        Cuerpo</button>
                                </div>
                            </div>



                            <table *ngIf="item.coqu_in_quiz_type==1" class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th *ngFor="let head of item.header" scope="col">
                                            {{head.coquhe_tx_description}}
                                        </th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let body of item.body">
                                        <th>{{body.coqubo_tx_description}}</th>
                                        <th *ngFor="let head of item.header" >
                                            <input type="radio" class="example-radio-button radio_table" name="{{body.coqubo_tx_description}}"  />
                                        </th>
                                        <th>
                                            <a (click)="deleteBody(body)" class="pr-2" ><i class="fa fa-remove"></i> Eliminar</a>
                                        </th>
                                    </tr>
                                    <tr  >
                                        <th></th>
                                        <th *ngFor="let head of item.header">
                                            <a (click)="deleteHeader(head)" class="pr-2"  ><i class="fa fa-remove"></i> Eliminar</a>
                                        </th>
                                        <th></th>
                                    </tr>
                                </tbody>
                            </table>

                            <mat-radio-group *ngIf="item.coqu_in_quiz_type==2"
                                aria-labelledby="example-radio-group-label" class="example-radio-group">
                                <mat-radio-button class="example-radio-button" *ngFor="let body of item.body"
                                    [value]="body.coqubo_tx_description">
                                    {{body.coqubo_tx_description}}

                                    <a (click)="deleteBody(body)" class="pr-2"  ><i class="fa fa-remove"></i> Eliminar</a>
                                    

                                </mat-radio-button>

                                

                            </mat-radio-group>

                            <ul *ngIf="item.coqu_in_quiz_type==3" style="padding-left: 0px;">
                                <li *ngFor="let body of item.body">
                                    <mat-checkbox>
                                        {{body.coqubo_tx_description}}
                                    </mat-checkbox>

                                    <a (click)="deleteBody(body)" class="pr-2" ><i class="fa fa-remove"></i> Eliminar</a>

                                </li>
                            </ul>

                            <div *ngIf="item.coqu_in_quiz_type==4" class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Escriba su respuesta en el cuadro de texto</label>
                                    <textarea class="form-control" disabled></textarea>
                                </div>
                            </div>
                        </ng-container>


                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>


    <div>
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
    </div>
</form>